export { FeaturedBanner } from './FeaturedBanner';
export type { FeaturedBannerProps } from './FeaturedBanner.types';
